import React from 'react';
import { getCPFMask } from '../../utils/InputMaskUtils';
import MaskedInput from 'react-text-mask';

const CPFMaskedInput = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={getCPFMask()}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export default CPFMaskedInput;
